/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "rewards": {
                "nested": {
                  "RewardConfig": {
                    "fields": {
                      "pointToCardSpendRatio": {
                        "type": "double",
                        "id": 1,
                        "rule": "optional"
                      },
                      "multipliers": {
                        "type": "squareup.corporate_card.resources.rewards.RewardConfig.RewardMulitplier",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "rewardType": {
                        "type": "squareup.corporate_card.resources.rewards.RewardConfig.RewardType",
                        "id": 3,
                        "rule": "optional"
                      },
                      "rewardEarnedBps": {
                        "type": "int32",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "RewardMulitplier": {
                        "fields": {
                          "merchantName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "multiplier": {
                            "type": "int32",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "RewardType": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "MULTIPLIERS": 1,
                          "FLAT_PROCESSING": 2
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardConfig && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardConfig?.nested?.RewardMulitplier && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.rewards?.nested?.RewardConfig?.nested?.RewardType) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A configuration for rewards
 * --
 *
 * SOURCE RewardConfig @ squareup/corporate_card/resources/rewards/reward_config.proto at 8:1
 */
export const RewardConfig = $root.lookupType('squareup.corporate_card.resources.rewards.RewardConfig');
fixType(RewardConfig);
Builder.createAndAttachToType(RewardConfig);
/**
 * --
 * @desc Multiplier for a vendor
 * --
 *
 * SOURCE RewardMulitplier @ squareup/corporate_card/resources/rewards/reward_config.proto at 13:3
 */
RewardConfig.RewardMulitplier = $root.lookupType('squareup.corporate_card.resources.rewards.RewardConfig.RewardMulitplier');
fixType(RewardConfig.RewardMulitplier);
Builder.createAndAttachToType(RewardConfig.RewardMulitplier);
/**
 * SOURCE RewardType @ squareup/corporate_card/resources/rewards/reward_config.proto at 25:3
 */
RewardConfig.RewardType = $root.lookupEnum('squareup.corporate_card.resources.rewards.RewardConfig.RewardType').values;